import React from 'react';
import { createRoot } from 'react-dom/client';

import IndexApp from './containers/IndexApp';

import '~/scss/pages/index.scss';

require('~/assets/images/3ia_data_logo.png');

createRoot(document.getElementById('index-app')).render(
    <IndexApp datasetListApiEndpoint = { DATASET_LIST_API_ENDPOINT } />
);
